// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-picker-container{padding-bottom:1em;position:relative}.file-picker-container .file-cards-container{display:flex;flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
